import { router } from 'expo-router';
import React from 'react';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import ItemUnavailableMessage from 'components/item-unavailable-message';
import { useIsDesktopBp } from 'hooks/breakpoints';
import { routes } from 'utils/routing';

import { useProductAvailability } from '../use-product-availability';

import { PRODUCT_CTA_LABEL_ID } from './constants';
import { ProductCtaWrapper } from './product-cta-wrapper';

export const ProductStaticMenuCta: React.FC<
  React.PropsWithChildren<{
    showStaticPickers?: boolean;
  }>
> = ({ showStaticPickers }) => {
  const { formatMessage } = useIntl();
  const { dayParts, isItemAvailableForDaypart, itemDayParts } = useProductAvailability();
  const isDesktop = useIsDesktopBp();

  const handleFindRestaurantClick = () => {
    router.replace(routes.storeLocator);
  };

  return (
    <ProductCtaWrapper
      elements={[
        {
          element: isItemAvailableForDaypart ? (
            <ActionButton onPress={handleFindRestaurantClick} fullWidth>
              {formatMessage({ id: PRODUCT_CTA_LABEL_ID })}
            </ActionButton>
          ) : (
            <ItemUnavailableMessage
              dayParts={dayParts}
              itemDayParts={itemDayParts}
              marginAndBorders={isDesktop && !showStaticPickers}
            />
          ),
        },
      ]}
    />
  );
};
